/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxNumberInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxnumberinput';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcNumberInputComponent),
    multi: true
};

/**
 * Number Input
 */

export class NgcNumberInputComponent extends ControlComponent {
     allowNull: any;
     decimal: any;
     decimalDigits: any;
     decimalSeparator: any;
     digits: any;
     groupSeparator: any;
     groupSize: any;
     inputMode: any;
     min: any;
     max: any;
     negativeSymbol: any;
     placeHolder: any;
     promptChar: any;
     rtl: any;
     readOnly: any;
     spinMode: any;
     spinButtons: any;
     spinButtonsWidth: any;
     spinButtonsStep: any;
     symbol: any;
     symbolPosition: any;
     textAlign: any;
     template: any;
     theme: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.args.value;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-numberinput',
    template: `<jqxNumberInput *ngIf="visible" (onChange)="inputChange($event)"
                [allowNull] = "allowNull"
                [decimal] = "decimal"
                [disabled] = "disabled"
                [decimalDigits] = "decimalDigits"
                [decimalSeparator] = "decimalSeparator"
                [digits] = "digits"
                [groupSeparator] = "groupSeparator"
                [groupSize] = "groupSize"
                [inputMode] = "inputMode"
                [min] = "min"
                [max] = "max"
                [negativeSymbol] = "negativeSymbol"
                [placeHolder] = "placeHolder"
                [promptChar] = "promptChar"
                [rtl] = "rtl"
                [readOnly] = "readOnly"
                [spinMode] = "spinMode"
                [spinButtons] = "spinButtons"
                [spinButtonsWidth] = "spinButtonsWidth"
                [spinButtonsStep] = "spinButtonsStep"
                [symbol] = "symbol"
                [symbolPosition] = "symbolPosition"
                [textAlign] = "textAlign"
                [template] = "template"
                [theme] = "theme"
                [value] = "value"
                [width] = "width"
                [height] = "height">
                </jqxNumberInput>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'allowNull': [{ type: Input, args: ['allowNull', ] },],
'decimal': [{ type: Input, args: ['decimal', ] },],
'decimalDigits': [{ type: Input, args: ['decimalDigits', ] },],
'decimalSeparator': [{ type: Input, args: ['decimalSeparator', ] },],
'digits': [{ type: Input, args: ['digits', ] },],
'groupSeparator': [{ type: Input, args: ['groupSeparator', ] },],
'groupSize': [{ type: Input, args: ['groupSize', ] },],
'inputMode': [{ type: Input, args: ['inputMode', ] },],
'min': [{ type: Input, args: ['min', ] },],
'max': [{ type: Input, args: ['max', ] },],
'negativeSymbol': [{ type: Input, args: ['negativeSymbol', ] },],
'placeHolder': [{ type: Input, args: ['placeHolder', ] },],
'promptChar': [{ type: Input, args: ['promptChar', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'readOnly': [{ type: Input, args: ['readOnly', ] },],
'spinMode': [{ type: Input, args: ['spinMode', ] },],
'spinButtons': [{ type: Input, args: ['spinButtons', ] },],
'spinButtonsWidth': [{ type: Input, args: ['spinButtonsWidth', ] },],
'spinButtonsStep': [{ type: Input, args: ['spinButtonsStep', ] },],
'symbol': [{ type: Input, args: ['symbol', ] },],
'symbolPosition': [{ type: Input, args: ['symbolPosition', ] },],
'textAlign': [{ type: Input, args: ['textAlign', ] },],
'template': [{ type: Input, args: ['template', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * Number Input Module
 */

export class NgcNumberInputModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcNumberInputComponent],
    declarations: [NgcNumberInputComponent, jqxNumberInputComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
